import clsx from 'clsx'
import { Fragment, useState } from 'react'
import React from 'react'

import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { useMedia } from '@wartek-id/react-utils'
import { Text } from '@wartek-id/text'

import { DataIndukFilterBentukPendidikanItem, RQStatus } from '@/apis/types'

import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioItem,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/CustomDropdown'

import { FilterBentukSheet } from './FilterBentukSheet'

interface FilterProps {
  bentuk: DataIndukFilterBentukPendidikanItem[]
  loadingStatus: RQStatus
  value: string
  onChange: (newValue: string) => void
  buttonClassName?: string
}

export const FilterBentuk = ({
  bentuk,
  loadingStatus,
  value,
  onChange,
  buttonClassName,
}: FilterProps) => {
  const [show, setShow] = useState(false)
  const isMd = useMedia('(min-width: 768px)', false)

  const findDisplayNameById = (id) => {
    let displayName = id
    for (let index = 0; index < bentuk.length; index++) {
      const bentukItem = bentuk[index]
      const found = bentukItem.bentukPendidikan.find((i) => i.id === id)

      if (found) {
        displayName = found.displayName
        break
      }
    }

    return displayName
  }

  return (
    <>
      <div className="flex w-full flex-col gap-2 lg:flex-row lg:items-center">
        <Text variant="body-sm-bold">Bentuk</Text>
        {!isMd ? (
          <Button
            color="white"
            className={clsx(
              'relative flex !justify-between gap-2 !pl-[16px] !pr-[40px] !font-normal',
              buttonClassName
            )}
            fullWidth
            disabled={loadingStatus === 'pending'}
            isLoading={loadingStatus === 'pending'}
            data-testid="btn-filter-bentuk"
            onClick={() => {
              setShow(true)
            }}
          >
            <span className="overflow-hidden text-clip whitespace-nowrap lg:max-w-[70px]">
              {value ? findDisplayNameById(value) : 'Semua'}
            </span>
            <span className="absolute right-0 top-0 flex h-full flex-col justify-center pr-2">
              <Icon className="">expand_more</Icon>
            </span>
          </Button>
        ) : (
          <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
              <Button
                color="white"
                className={clsx(
                  'relative flex !justify-between gap-2 !pl-[16px] !pr-[40px] !font-normal',
                  buttonClassName
                )}
                fullWidth
                disabled={loadingStatus === 'pending'}
                isLoading={loadingStatus === 'pending'}
                data-testid="btn-filter-bentuk"
              >
                <span className="overflow-hidden text-clip whitespace-nowrap lg:max-w-[70px]">
                  {value ? findDisplayNameById(value) : 'Semua'}
                </span>
                <span className="absolute right-0 top-0 flex h-full flex-col justify-center pr-2">
                  <Icon className="">expand_more</Icon>
                </span>
              </Button>
            </DropdownMenu.Trigger>

            <DropdownMenuContent>
              <DropdownMenuItem
                onClick={() => {
                  onChange('')
                }}
                data-testid="item-bentuk-all"
              >
                Semua Bentuk
              </DropdownMenuItem>
              {bentuk.map((item) => (
                <Fragment key={item.id}>
                  {item.bentukPendidikan ? (
                    <DropdownMenu.Sub>
                      <DropdownMenuSubTrigger
                        data-testid={`item-bentuk-${item.id}`}
                        withIcon={true}
                      >
                        {item.displayName}
                      </DropdownMenuSubTrigger>
                      <DropdownMenu.Portal>
                        <DropdownMenuSubContent sideOffset={2} alignOffset={-5}>
                          <DropdownMenu.RadioGroup
                            value={value}
                            onValueChange={(newValue) => {
                              onChange(newValue)
                            }}
                          >
                            {item.bentukPendidikan.map((child) => (
                              <DropdownMenuRadioItem
                                key={child.id}
                                value={child.id}
                                data-testid={`child-bentuk-${child.id}`}
                              >
                                {child.displayName}
                              </DropdownMenuRadioItem>
                            ))}
                          </DropdownMenu.RadioGroup>
                        </DropdownMenuSubContent>
                      </DropdownMenu.Portal>
                    </DropdownMenu.Sub>
                  ) : null}
                </Fragment>
              ))}
            </DropdownMenuContent>
          </DropdownMenu.Root>
        )}
      </div>
      {!isMd && (
        <FilterBentukSheet
          show={show}
          bentuk={bentuk}
          value={value}
          onClose={() => {
            setShow(false)
          }}
          onSelect={(newValue) => {
            onChange(newValue)
          }}
        />
      )}
    </>
  )
}
